import React from 'react';
import {
    Container,
    CssBaseline,
    ThemeProvider as MUIThemeProvider,
    Paper,
} from '@mui/material';

import theme from '@/operator/layout/theme/theme';
import globalStyles from '@/layouts/theme/globalStyles';

interface Props {
    children: React.ReactNode;
}

const OperatorThemeProvider: React.FC<Props> = ({ children }) => {
    return (
        <MUIThemeProvider theme={theme}>
            <CssBaseline />
            {globalStyles}
            {children}
        </MUIThemeProvider>
    );
};

export default OperatorThemeProvider;
